var map = {
	"./en-US.js": 5870,
	"./ja.js": 9758,
	"./ko-KR.js": 4089,
	"./pt-BR.js": 378,
	"./zh-CN.js": 2434,
	"./zh-HK.js": 3441,
	"./zh-TW.js": 3237
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 2435;
module.exports = webpackAsyncContext;